import { createSlice } from '@reduxjs/toolkit';

// Initial state
const langList = [
  { id: 1, code: 'en', title: 'English', isActive: false},
  { id: 2, code: 'ja', title: '日本語', isActive: false}
];
const initialState = { langList };

// Local storeage
export const localStorageKey = 'lang';
let selectedLang = localStorage.getItem(localStorageKey);
!selectedLang && localStorage.setItem(localStorageKey, langList[0].code);

for (let lang of langList) {
  lang.code === selectedLang && (lang.isActive = true);
}

const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    changeLang(state, action) {
      state.langList = action.payload;
    }
  }
});

export const selectLangList = (state) => state.lang.langList;
export const selectSelectedLang = (state) => state.lang.langList.filter(lang => lang.isActive);

export const langActions = langSlice.actions;

export default langSlice;